import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";

import ArgonBox from "components/ArgonBox";

import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components

// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import breakpoints from "assets/theme/base/breakpoints";
import { Button, InputLabel, Box, Avatar, CircularProgress } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WorkIcon from "@mui/icons-material/Work";
import LockIcon from "@mui/icons-material/Lock";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

import { useState, useEffect } from "react";

import { Grid, Alert, Snackbar } from "@mui/material";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import api from "utils/api";
import { Table, TableBody, TableCell, TableRow, Checkbox, IconButton } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Dropdown from "components/CustomDropdown/Dropdown";
import FileUploader from "components/FileUploader/FileUploader";

function AddNotification() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  // Determine if we're in edit mode
  const isEditMode = Boolean(id || location.state?.notification);
  const notificationData = location.state?.notification;

  // Form state
  const [formData, setFormData] = useState({
    type: "NOTIFICATION",
    title: "",
    description: "",
    userType: "PARENT_ALL",
    notificationPlatform: "PUSH",
    scheduled: false,
    parentId: [],
    tutorId: [],
  });

  const [photoFile, setPhotoFile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // Lists for dropdowns
  const [tutors, setTutors] = useState([]);
  const [parents, setParents] = useState([]);
  const [loadingTutors, setLoadingTutors] = useState(false);
  const [loadingParents, setLoadingParents] = useState(false);

  // Initialize form data for edit mode
  useEffect(() => {
    if (isEditMode && notificationData) {
      setFormData({
        type: notificationData.type || "NOTIFICATION",
        title: notificationData.title || "",
        description: notificationData.description || "",
        userType: notificationData.userType || "PARENT_ALL",
        notificationPlatform: notificationData.notificationPlatform || "PUSH",
        scheduled: notificationData.scheduled || false,
        parentId: Array.isArray(notificationData.parentId)
          ? notificationData.parentId
          : notificationData.parentId
          ? [notificationData.parentId]
          : [],
        tutorId: Array.isArray(notificationData.tutorId)
          ? notificationData.tutorId
          : notificationData.tutorId
          ? [notificationData.tutorId]
          : [],
      });
    }
  }, [isEditMode, notificationData]);

  // Fetch tutors when userType changes to TEACHER_CUSTOM
  useEffect(() => {
    if (formData.userType === "TEACHER_CUSTOM") {
      fetchTutors();
    }
  }, [formData.userType]);

  // Fetch parents when userType changes to PARENT_CUSTOM
  useEffect(() => {
    if (formData.userType === "PARENT_CUSTOM") {
      fetchParents();
    }
  }, [formData.userType]);

  // Fetch tutors list
  const fetchTutors = async () => {
    try {
      setLoadingTutors(true);
      const response = await api.get("/tutor");
      if (response.data.success) {
        const tutorOptions = response.data.data.tutors.map((tutor) => ({
          value: tutor._id || tutor.id,
          label: `${tutor.fullName} - ${tutor.phone}`,
        }));
        setTutors(tutorOptions);
      }
    } catch (error) {
      console.error("Error fetching tutors:", error);
      showSnackbar("Failed to fetch tutors", "error");
    } finally {
      setLoadingTutors(false);
    }
  };

  // Fetch parents list
  const fetchParents = async () => {
    try {
      setLoadingParents(true);
      const response = await api.get("/parent");
      if (response.data.success) {
        const parentOptions = response.data.data.map((parent) => ({
          value: parent._id,
          label: `${parent.fullName} - ${parent.phone}`,
        }));
        setParents(parentOptions);
      }
    } catch (error) {
      console.error("Error fetching parents:", error);
      showSnackbar("Failed to fetch parents", "error");
    } finally {
      setLoadingParents(false);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle checkbox changes for multiple selection
  const handleCheckboxChange = (name, value) => {
    setFormData((prev) => {
      const currentArray = Array.isArray(prev[name]) ? prev[name] : [];
      const isSelected = currentArray.includes(value);
      const newArray = isSelected
        ? currentArray.filter((item) => item !== value)
        : [...currentArray, value];
      return {
        ...prev,
        [name]: newArray,
      };
    });
  };

  // Handle dropdown changes
  const handleDropdownChange = (name) => (e) => {
    const value = e.target.value;
    setFormData((prev) => {
      const newData = {
        ...prev,
        [name]: value,
      };

      // Clear tutorId/parentId when userType changes
      if (name === "userType") {
        if (
          value === "TEACHER_ALL" ||
          value === "PARENT_ALL" ||
          value === "PARENT_CUSTOM" ||
          value === "PARENT_ALL"
        ) {
          newData.tutorId = [];
        }
        if (
          value === "TEACHER_ALL" ||
          value === "PARENT_ALL" ||
          value === "TEACHER_CUSTOM" ||
          value === "TEACHER_ALL"
        ) {
          newData.parentId = [];
        }
      }

      return newData;
    });
  };

  // Show snackbar
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  // Close snackbar
  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Create FormData for file upload
  const createFormData = (data, file = null) => {
    const formData = new FormData();

    // Add all text fields
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (value !== null && value !== undefined && value !== "") {
        if (Array.isArray(value)) {
          // For arrays, append each item
          value.forEach((item) => {
            formData.append(key, item);
          });
        } else {
          formData.append(key, value);
        }
      }
    });

    // Add file if provided
    if (file && file[0]?.file) {
      formData.append("photo", file[0].file);
    }

    return formData;
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const normalizedTitle = (formData.title || "").trim();
    const normalizedUserType = (formData.userType || "").trim();
    const normalizedType = (formData.type || "").trim();

    // Basic validation
    if (!normalizedTitle || !normalizedUserType || !normalizedType) {
      showSnackbar("Please fill in all required fields", "error");
      return;
    }

    // Validate custom selections
    if (
      formData.userType === "TEACHER_CUSTOM" &&
      (!Array.isArray(formData.tutorId) || formData.tutorId.length === 0)
    ) {
      showSnackbar("Please select at least one tutor", "error");
      return;
    }

    if (
      formData.userType === "PARENT_CUSTOM" &&
      (!Array.isArray(formData.parentId) || formData.parentId.length === 0)
    ) {
      showSnackbar("Please select at least one parent", "error");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        ...formData,
        title: normalizedTitle,
        userType: normalizedUserType,
        type: normalizedType,
      };

      // Create FormData for file upload
      const submitData = createFormData(payload, photoFile);

      let response;
      if (isEditMode && notificationData?._id) {
        response = await api.put(`/notification/${notificationData._id}`, submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await api.post("/notification", submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (response.data.success) {
        let message = isEditMode
          ? "Notification updated successfully"
          : "Notification created successfully";

        // Use backend response shape: recipientsCount.push + sendResults.push
        if (formData.notificationPlatform === "PUSH") {
          const pushRecipients = Number(response?.data?.recipientsCount?.push || 0);
          const pushResult = response?.data?.sendResults?.push;
          const pushSuccessCount = Number(pushResult?.successCount || 0);

          if (pushRecipients <= 0) {
            message += " (No recipients with FCM tokens found)";
          } else if (pushSuccessCount > 0) {
            message += ` (Push sent to ${pushSuccessCount} device${
              pushSuccessCount > 1 ? "s" : ""
            })`;
          } else if (pushResult?.success === false && pushResult?.error) {
            message += ` (Push failed: ${pushResult.error})`;
          } else {
            message += ` (Push attempted for ${pushRecipients} device${
              pushRecipients > 1 ? "s" : ""
            })`;
          }
        }

        showSnackbar(message, "success");
        setTimeout(() => {
          navigate("/notification");
        }, 2000);
      } else {
        showSnackbar(response.data.message || "Operation failed", "error");
      }
    } catch (error) {
      showSnackbar(error.response?.data?.message || "Operation failed", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card
        sx={{
          borderRadius: "16px",
          backgroundColor: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
          border: "1px solid #e0e0e0",
          position: "relative",
          overflow: "hidden",
          // maxWidth: "900px", // form ki width control
          margin: "auto",
        }}
      >
        {/* Decorative Background Element */}
        <ArgonBox
          sx={{
            position: "absolute",
            top: -40,
            right: -40,
            width: 120,
            height: 120,
            background: "linear-gradient(45deg, #667eea, #764ba2)",
            borderRadius: "50%",
            opacity: 0.05,
          }}
        />

        <ArgonBox p={3}>
          {/* Header */}
          <ArgonBox display="flex" alignItems="center" gap={2} mb={3}>
            <ArgonBox
              sx={{
                background: "linear-gradient(45deg, #667eea, #764ba2)",
                borderRadius: "10px",
                p: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 3px 10px rgba(102, 126, 234, 0.2)",
              }}
            >
              {/* <Notifications sx={{ color: "white", fontSize: "20px" }} /> */}
            </ArgonBox>
            <ArgonBox>
              <ArgonTypography variant="h5" fontWeight="medium" color="#2c3e50">
                {isEditMode ? "Edit Notification" : "Create Notification"}
              </ArgonTypography>
              <ArgonTypography variant="body2" color="#6c757d">
                {isEditMode
                  ? "Update notification details"
                  : "Send notifications and notices to users"}
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Configuration Section */}
              <Grid item xs={12}>
                <ArgonBox
                  sx={{
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    p: 2,
                    border: "1px solid #e9ecef",
                  }}
                >
                  <ArgonTypography variant="subtitle1" fontWeight="medium" color="text" mb={2}>
                    Configuration
                  </ArgonTypography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        label="User Type *"
                        value={formData.userType}
                        options={[
                          { value: "TEACHER_ALL", label: "All Teachers" },
                          { value: "TEACHER_CUSTOM", label: "Custom Teachers" },
                          { value: "PARENT_ALL", label: "All Parents" },
                          { value: "PARENT_CUSTOM", label: "Custom Parents" },
                        ]}
                        onChange={handleDropdownChange("userType")}
                        width={300}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        label="Notification Type *"
                        value={formData.type}
                        options={[
                          { value: "NOTIFICATION", label: "Notification" },
                          { value: "NOTICE", label: "Notice" },
                        ]}
                        onChange={handleDropdownChange("type")}
                        width={300}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        label="Platform"
                        value={formData.notificationPlatform}
                        options={[
                          { value: "NORMAL", label: "Normal" },
                          { value: "PUSH", label: "Push Notification (FCM)" },
                          { value: "WHATSAPP", label: "WhatsApp" },
                        ]}
                        onChange={handleDropdownChange("notificationPlatform")}
                        width={300}
                      />
                    </Grid>

                    {/* Show tutor checkboxes when TEACHER_CUSTOM is selected */}
                    {formData.userType === "TEACHER_CUSTOM" && (
                      <Grid item xs={12} md={6}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Select Tutors *
                        </ArgonTypography>
                        {loadingTutors ? (
                          <ArgonBox display="flex" alignItems="center" gap={1}>
                            <CircularProgress size={20} />
                            <ArgonTypography variant="body2">Loading tutors...</ArgonTypography>
                          </ArgonBox>
                        ) : (
                          <ArgonBox
                            sx={{
                              maxHeight: 200,
                              overflowY: "auto",
                              border: "1px solid #e0e7ff",
                              borderRadius: "8px",
                              p: 1,
                            }}
                          >
                            {tutors.map((tutor) => (
                              <ArgonBox
                                key={tutor.value}
                                display="flex"
                                alignItems="center"
                                mb={0.5}
                              >
                                <Checkbox
                                  checked={formData.tutorId.includes(tutor.value)}
                                  onChange={() => handleCheckboxChange("tutorId", tutor.value)}
                                  color="primary"
                                />
                                <ArgonTypography variant="body2" ml={1}>
                                  {tutor.label}
                                </ArgonTypography>
                              </ArgonBox>
                            ))}
                          </ArgonBox>
                        )}
                      </Grid>
                    )}

                    {/* Show parent checkboxes when PARENT_CUSTOM is selected */}
                    {formData.userType === "PARENT_CUSTOM" && (
                      <Grid item xs={12} md={6}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Select Parents *
                        </ArgonTypography>
                        {loadingParents ? (
                          <ArgonBox display="flex" alignItems="center" gap={1}>
                            <CircularProgress size={20} />
                            <ArgonTypography variant="body2">Loading parents...</ArgonTypography>
                          </ArgonBox>
                        ) : (
                          <ArgonBox
                            sx={{
                              maxHeight: 200,
                              overflowY: "auto",
                              border: "1px solid #e0e7ff",
                              borderRadius: "8px",
                              p: 1,
                            }}
                          >
                            {parents.map((parent) => (
                              <ArgonBox
                                key={parent.value}
                                display="flex"
                                alignItems="center"
                                mb={0.5}
                              >
                                <Checkbox
                                  checked={formData.parentId.includes(parent.value)}
                                  onChange={() => handleCheckboxChange("parentId", parent.value)}
                                  color="primary"
                                />
                                <ArgonTypography variant="body2" ml={1}>
                                  {parent.label}
                                </ArgonTypography>
                              </ArgonBox>
                            ))}
                          </ArgonBox>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </ArgonBox>
              </Grid>

              {/* Content Section */}
              <Grid item xs={12}>
                <ArgonBox
                  sx={{
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    p: 2,
                    border: "1px solid #e9ecef",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={1}>
                        Title *
                      </ArgonTypography>
                      <ArgonInput
                        fullWidth
                        name="title"
                        placeholder="Enter notification title"
                        value={formData.title}
                        onChange={handleInputChange}
                        required
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonBox
                        sx={{
                          border: "2px dashed #4ECDC4",
                          borderRadius: "10px",
                          p: 2,
                          textAlign: "center",
                          backgroundColor: "#fff",
                          maxWidth: "480px",
                          minHeight: "100px",
                          margin: "auto",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            backgroundColor: "#f0fdfd",
                            borderColor: "#2196F3",
                            boxShadow: "0 3px 10px rgba(78, 205, 196, 0.2)",
                          },
                        }}
                      >
                        <ArgonBox>
                          <FileUploader
                            label={
                              isEditMode && notificationData?.photo
                                ? "Update Banner"
                                : "Upload Banner"
                            }
                            files={photoFile}
                            setFiles={setPhotoFile}
                            accept="image/*"
                            multiple={false}
                            Width="100%"
                            Height={90}
                          />
                          {isEditMode && notificationData?.photo && !photoFile.length && (
                            <ArgonBox mb={2}>
                              <ArgonTypography variant="caption" color="text" mb={1}>
                                Current Banner Image:
                              </ArgonTypography>
                              <ArgonBox>
                                <img
                                  src={notificationData.photo}
                                  alt="Current Banner"
                                  height="80px"
                                  width="140px"
                                  style={{
                                    border: "1px solid #e0e7ff",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                  }}
                                />
                              </ArgonBox>
                              <ArgonTypography variant="caption" color="text" mt={1}>
                                Current photo will be kept if no new photo is selected
                              </ArgonTypography>
                            </ArgonBox>
                          )}
                        </ArgonBox>
                      </ArgonBox>
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={1}>
                        Description
                      </ArgonTypography>
                      <ArgonInput
                        fullWidth
                        multiline
                        rows={3}
                        name="description"
                        placeholder="Enter notification description..."
                        value={formData.description}
                        onChange={handleInputChange}
                      />
                    </Grid>
                  </Grid>
                </ArgonBox>
              </Grid>

              {/* Action Buttons */}
              <Grid item xs={12}>
                <ArgonBox
                  sx={{
                    background: "white",
                    borderRadius: "12px",
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <ArgonButton
                    component={Link}
                    to="/notification"
                    variant="outlined"
                    size="small"
                    color="primary"
                    disabled={loading}
                  >
                    Cancel
                  </ArgonButton>

                  <ArgonBox display="flex" gap={2}>
                    <ArgonButton
                      type="submit"
                      variant="contained"
                      size="small"
                      color="primary"
                      disabled={loading}
                    >
                      {loading
                        ? isEditMode
                          ? "Updating..."
                          : "Creating..."
                        : isEditMode
                        ? "Update Notification"
                        : "Create Notification"}
                    </ArgonButton>
                  </ArgonBox>
                </ArgonBox>
              </Grid>
            </Grid>
          </form>
        </ArgonBox>
      </Card>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Footer />
    </DashboardLayout>
  );
}

export default AddNotification;
